<template>
  <div class="legal-component w-full h-full flex items-center justify-center" refs="legal-component">
    <div :class="{
      'legal-section bg-linear-to-b p-6 w-[564px] h-[474px]': true,
      'from-[#69DFD880] to-[#6B2AA880]': !isActivate,
      'from-[#69DFD8] to-[#6B2AA8]': isActivate
    }">
      <h1 class="text-center text-white text-[28px] font-bold mb-4 uppercase">{{$t('legal.legal')}}</h1>
      <template v-for="(item, indx) in legalItems">
        <div
          v-if="item.isVisible"
          :key="indx"
          class="legal-item flex justify-between items-center py-[21px] border-t border-white text-[15px]">
          <span class="text-white text-left truncate">{{ item.title }}</span>

          <button v-if="item.pdfLink"
            @click="handleDownloadFile(item.pdfLink, item.title)"
            class="download-button bg-transparent border border-white rounded-full text-white w-[188px] py-1 hover:bg-[#7463BC] text-[16px] truncate cursor-pointer">{{$t('legal.downloadPDF')}}</button>
          <a v-if="item.webLink"
            :href="item.webLink"
            target="_blank"
            class="g-transparent cursor-pointer">
            <font-awesome-icon icon="fa-solid fa-external-link" class="w-[16px] h-[16px] text-white text-xs"/></a>
        </div>
      </template>
    </div>
  </div>
</template>

<script src="./legal.js"></script>
<style lang="scss" src="./legal.scss"></style>
